import React from "react";
import { Card, CardBody, CardImg, CardText, CardTitle, Col, Container, Row } from "reactstrap";
import { selectors, useAppSelector } from "../../state";
import { isStudent } from "../../services";
import careerVideos from "../../assets/career_videos.json";
import { Link } from "react-router-dom";
import TestimonialComment from "./TestimonialComment";
import { IsaacVideo } from "../content/IsaacVideo";

const CsAtWorkDescription = () => {
  const user = useAppSelector(selectors.user.orNull);
  const loggedOutDescription =
    "Enrich your understanding of computer science curriculum topics with our video resources. Watch a Computing Ambassador introduce a topic and share what they do in their day-to-day job.";
  const student =
    "Wondering how studying computer science can help you in your future job or where would you ever use this knowledge? Our new video resources are here to show you the real-world application of your learning. Watch a Computing Ambassador introduce a topic and share what they do in their day-to-day job.";
  const teacherOrAbove =
    "Looking at how to connect your students' learning of computer science and the real world of work? Our new video resources are here to help you bring the curriculum topics to life with Computing Ambassadors introducing topics and sharing what they do in their day-to-day job.";

  const roleSpecificDescription = isStudent(user) ? student : teacherOrAbove;

  return <span className="mb-3">{!user?.loggedIn ? loggedOutDescription : roleSpecificDescription}</span>;
};

interface CareerCardProps {
  imgSrc?: string;
  imgAlt?: string;
  title: string;
  text: string | JSX.Element;
  linkTo: string;
  linkText: string;
  children?: React.ReactNode;
}

const CareerCard = ({ imgSrc, imgAlt, title, text, linkTo, linkText, children }: CareerCardProps) => (
  <Card className="career-card h-100 w-100">
    {imgSrc && <CardImg variant="top" src={imgSrc} alt={imgAlt} className="career-media-row-image" />}
    <CardBody className="career-card-body d-flex flex-column">
      {children}
      <CardTitle className="career-subtitle">{title}</CardTitle>
      <CardText className="career-text">{text}</CardText>
      <div className="career-link-column mt-auto">
        <Link className="career-link" to={linkTo}>
          {linkText}
        </Link>
      </div>
    </CardBody>
  </Card>
);

const videoId = careerVideos[0].video;

export const CareersBanner = () => {
  const user = useAppSelector(selectors.user.orNull);
  return (
    <div className="career-background-img">
      <Container className="pt-4 pb-5">
        <Container className="career-section">
          <h4 className="career-title mb-4">Careers</h4>
          <Row className="career-media-row justify-content-center pb-5">
            <Col xs={12} sm={10} lg={6}>
              <CareerCard
                imgSrc="/assets/cs_journeys.png"
                imgAlt="cs journeys"
                title="Computer Science Journeys"
                text="Discover our interview series and learn from passionate educators within the Isaac community, and recently graduated computer scientists, who are doing amazing things in a huge range of computing-related fields."
                linkTo="/pages/computer_science_journeys_gallery"
                linkText="Read our interviews"
              />
            </Col>
            <Col className="mt-4 mt-lg-0" xs={12} sm={10} lg={6}>
              <CareerCard
                title={isStudent(user) ? "Linking computer science to the real world" : "Computer Science at work"}
                text={<CsAtWorkDescription />}
                linkTo="/careers_in_computer_science"
                linkText="See more career videos"
              >
                <div className="career-media-row-column">
                  <IsaacVideo
                    doc={{ type: "video", src: `https://www.youtube.com/watch?v=${videoId}`, altText: "career-video" }}
                  />
                </div>
              </CareerCard>
            </Col>
          </Row>
        </Container>

        <TestimonialComment
          imageSrc="/assets/star.svg"
          altText="Star"
          text='"Isaac Computer Science is such a valuable resource for homework and revision. Attending one of
                their discovery events expanded my understanding of computer science. Since then, I&apos;ve consistently
                used the platform, finding it invaluable in my computer science journey." - Lauren Lo'
        />
      </Container>
    </div>
  );
};
